import React from "react";

const InputField = ({
  label,
  type = "text",
  id,
  value,
  onChange,
  required = false,
  error,
  labelClassName = "auth-label",
  inputClassName = "auth-input",
  inputWrapperClassName = "auth-input-wrapper",
  labelContent,
  rightElement,
  ...props
}) => {
  return (
    <>
      <label className={labelClassName} htmlFor={id}>
        {labelContent || (
          <>
            {label}
            {required && <span className="required-star">*</span>}
          </>
        )}
      </label>
      <div className={inputWrapperClassName}>
        <input
          id={id}
          type={type}
          className={inputClassName}
          value={value}
          onChange={onChange}
          required={required}
          {...props}
        />
        {rightElement}
      </div>
      {error && <div className="form-error">{error}</div>}
    </>
  );
};

export default InputField;
